import { Badge, Icon, Tooltip } from "@intility/bifrost-react";
import { roleIcon, roleLabel, roleState } from "../lib/roles";

// A circle: width and height both equal the normal badge height (line height
// plus the badge's vertical padding).
const ICON_BADGE_SIDE = "calc(1lh + 2 * var(--bfs2))";
const ICON_BADGE_STYLE = {
  display: "inline-grid",
  placeItems: "center",
  width: ICON_BADGE_SIDE,
  height: ICON_BADGE_SIDE,
  padding: 0,
} as const;

// The badge of a role or an access type, the same everywhere: a pill with the
// role's icon and name, in the role's colour (lib/roles). `iconOnly` makes it a
// circle with just the icon; the name moves to the tooltip and the aria-label.
export function RoleBadge({
  role,
  iconOnly = false,
  tooltip,
}: {
  role: string;
  iconOnly?: boolean;
  /** The icon-only tooltip text; defaults to the role's name. */
  tooltip?: string;
}) {
  if (iconOnly) {
    const text = tooltip ?? roleLabel(role);
    return (
      <Tooltip content={text}>
        <Badge
          pill
          state={roleState(role)}
          aria-label={text}
          style={ICON_BADGE_STYLE}
        >
          <Icon icon={roleIcon(role)} />
        </Badge>
      </Tooltip>
    );
  }
  return (
    <Badge pill state={roleState(role)}>
      <Icon icon={roleIcon(role)} marginRight />
      {roleLabel(role)}
    </Badge>
  );
}
